<go-back class="w-full flex-start flex sm:hidden"></go-back>
<div class="flex flex-col justify-between items-center w-full h-full page-wrapper">
  <div class="w-full h-full flex flex-col justify-center items-center">
    <div class="flex flex-col text-center justify-center items-center header gap-4">
      <h4 class="heading-medium outfit extra-bold">{{ 'faq.header' | translate }}</h4>
      <p class="paragraph-medium outfit">{{ 'faq.sub-header' | translate }}</p>
    </div>
    <div class="flex w-full justify-center items-center overflow-hidden py-8 md:pt-10 md:pb-14 rounded-md">
      <img [src]="'assets/img/faq/faq-desktop.webp'" alt="" class="h-auto w-full object-cover hidden md:block" />
      <img [src]="'assets/img/faq/faq-mobile.webp'" alt="" class="w-full object-cover shrink-0 block md:hidden" />
    </div>
    <div class="w-full pb-3 z-[11]">
      <app-search
        inputType="faq"
        [searchFn]="searchFn"
        (emptyQuery)="onEmptyQuery()"
        (searchResultClick)="onSearchResultClick($event)"
      ></app-search>
    </div>
    <div class="w-full relative min-h-20">
      @if (isLoading) {
        <korviu-loader></korviu-loader>
      } @else {
        <div class="py-6">
          @if (!categories.length) {
            <korviu-no-data></korviu-no-data>
          }
          <nz-collapse [nzGhost]="true" [nzBordered]="false" [nzExpandIconPosition]="'end'" class="w-full">
            @for (panel of categories; track panel) {
              <nz-collapse-panel [nzHeader]="headerTemplate" [(nzActive)]="panel.active">
                <ng-template #headerTemplate>
                  <div class="flex flex-col gap-2 justiy-start items-start">
                    <span class="paragraph-medium outfit header font-bold">{{ panel.name | translate }}</span>
                  </div>
                </ng-template>
                @if (!!getQuestionsByCategoryId(panel.id)?.length) {
                  <faq-answer
                    [questions]="getQuestionsByCategoryId(panel.id)"
                    (activeChange)="onActiveChange($event, panel)"
                  ></faq-answer>
                }
              </nz-collapse-panel>
            }
          </nz-collapse>
        </div>
        <nz-pagination
          nzHideOnSinglePage
          class="pagination text-center"
          [nzPageIndex]="pagination.page"
          [nzTotal]="total"
          [nzSize]="'small'"
          (nzPageIndexChange)="onEventsListPageIndexChange($event)"
        ></nz-pagination>
      }
    </div>
  </div>
  <div class="relative w-full pt-10 md:pt-[76px] bottom-0 text-center footer flex flex-col gap-6 md:gap-8">
    <p class="paragraph-medium">{{ 'faq.contact-help' | translate }}</p>
    <korviu-button class="w-full" type="submit" color="tertiary" (onclick)="showContactUsForm()">{{
      'faq.contact-help-header' | translate
    }}</korviu-button>
  </div>
</div>
